// extracted by mini-css-extract-plugin
export default {"container":"Billing_container__tjlEl","text":"Billing_text__nlsHP","value":"Billing_value__E2FPb","manageBillingBtn":"Billing_manageBillingBtn__oSUL6"};